import { render, staticRenderFns } from "./cModalCentral.vue?vue&type=template&id=0c3c8295"
import script from "./cModalCentral.vue?vue&type=script&lang=js"
export * from "./cModalCentral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports